import React, { useState } from "react";
import { WizardData } from "./OfferWizard";
import DayPlanFullscreen from "../day-plan-fullscreen/DayPlanFullscreen";

interface PlanDayStepProps {
  data: WizardData;
  updateData: (data: Partial<WizardData>) => void;
  onNext: () => void;
  onPrev: () => void;
}

const PlanDayStep: React.FC<PlanDayStepProps> = ({
  data,
  updateData,
  onNext,
  onPrev,
}) => {
  const [currentDayIndex] = useState(0);

  // Use new fullscreen component if data is available
  if (data.offerId && data.offerDays) {
    return (
      <DayPlanFullscreen
        offerId={data.offerId}
        offerDays={data.offerDays}
        currentDayIndex={currentDayIndex}
        onUpdateData={updateData}
        onNext={onNext}
        onPrev={onPrev}
        checkInDate={data.checkInDate}
        checkOutDate={data.checkOutDate}
        numberOfGuests={data.numberOfGuests}
      />
    );
  }

  // Fallback for missing data
  return (
    <div className="space-y-6">
      <div className="text-center text-gray-500">Loading day plan...</div>
      <div className="flex justify-between pt-6">
        <button onClick={onPrev} className="btn-secondary">
          Wstecz
        </button>
        <button onClick={onNext} className="btn-primary">
          Dalej - Podsumowanie
        </button>
      </div>
    </div>
  );
};

export default PlanDayStep;
